import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, collection, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import Header from '../master_root/header';
//page links  
import Photosicon from '../assets/photos_icon.png';
import { GetAgoTime } from '../components/getAgoTime';
import { Randomcode } from '../components/rendom_code';
import './feed-view.css';
import { AiFillLike, AiFillDislike } from "react-icons/ai";
import { MdAdd, MdUpload, } from 'react-icons/md';
import ShareButton from '../components/ShareButton';
import { Savefeedlike } from './Save_feed_likes';
import { Savefeedcomment } from './Save_feed_comment';
import { Savesubscriber } from '../profile_root/Save_subscriber';
import { Incrementviews } from './incrementviews';
import Statusbar from '../master_root/statusbar';
export default function Feedview({ data = {} }) {
  const location = useLocation(); // Get current route
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [feedlike, setFeedlike] = useState(data.like);
  const [usersubscriber, setusersubscriber] = useState(0);
  const [yousubscribed, setyousubscribed] = useState(false);
  const [usersguid, setusersguid] = useState("");
  const [UsersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const [userlogin, setuserlogin] = useState(false);
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setuserlogin(true);
    } else {
      setuserlogin(false);
    }
  }, []);

  useEffect(() => {
    Incrementviews(data.uid); 
    fetchusers();
  }, []); // runs once on mount
  const fetchusers = async () => {

    try {

      // Assuming you have already initialized `db` and have `data.uid`

      const userQuery = query(
        collection(db, "users"),
        where("guid", "==", data.guid) // use existingUser directly
      );
      const userSnapshot = await getDocs(userQuery);
      const dataList = await Promise.all(
        userSnapshot.docs.map(async (doc) => {
          const usersData = { id: doc.id, ...doc.data() };
          setusersubscriber(usersData.subscriber);
          setusersguid(usersData.guid);
          // const detailsQuery = query(
          //   collection(db, "users_details"),
          //   where("guid", "==", usersData.guid)
          // );

          // const detailsSnapshot = await getDocs(detailsQuery);
          // const detailsData = detailsSnapshot.docs.map((detailsDoc) => ({
          //   uid: detailsDoc.id,
          //   ...detailsDoc.data(),
          // }))[0] || null;
          //, DetailsData: detailsData,

          return {
            ...usersData
          };
        })
      );
      setIsLoading(false);
      setUsersData(dataList);
      you_subscribed();
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  //Savesubscriber
  const post_Savesubscriber = async (e) => {
    if (userlogin == false) {
      setLoading(false);
       navigate('/login');
      return;
    }
    if (!data.uid) {
      setLoading(false);
      showToast("User ID missing");
      return;
    }

    setLoading(true);

    const result = await Savesubscriber({
      uid: Randomcode(15),
      userguid: data.guid,
      subscriber: usersubscriber,
    });

    setLoading(false); // Always turn off loading at the end

    if (result.success && result.removed) {
      // Like removed → decrement
      setTimeout(() => {
        setusersubscriber((prev) => Math.max(0, prev - 1));
        setyousubscribed(false);
      }, 1000);
    } else if (result.success && result.saved) {
      // Like added → increment
      setTimeout(() => {
        setusersubscriber((prev) => prev + 1);
        showToast("Congratulations");
        setyousubscribed(true);
      }, 1000);
    } else {
      showToast("Failed to publish");
    }
  };

  const you_subscribed = async () => {
    const guid = Cookies.get("guid");
    // Safety check
    if (!data?.guid || !guid) {
      console.error("Missing userguid or guid");
      setyousubscribed(false);
      return;
    }

    const subQuery = query(
      collection(db, "subscriber"),
      where("userguid", "==", data.guid),
      where("guid", "==", guid)
    );

    try {
      const subscriberSnapshot = await getDocs(subQuery);
      if (!subscriberSnapshot.empty) {
        setyousubscribed(true);
      } else {
        setyousubscribed(false);
      }
    } catch (error) {
      console.error("Error checking subscription:", error);
      setyousubscribed(false);
    }
  };
  //like
  const post_Savefeedlike = async (e) => {
    if (userlogin == false) {
      setLoading(false);
         navigate('/login');
      return;
    }
    if (!data.uid) {
      setLoading(false);
      showToast("User ID missing");
      return;
    }

    setLoading(true);

    const result = await Savefeedlike({
      uid: Randomcode(15),
      feeduid: data.uid,
      feedlike,
    });

    setLoading(false); // Always turn off loading at the end

    if (result.success && result.removed) {
      // Like removed → decrement
      setTimeout(() => {
        setFeedlike((prev) => Math.max(0, prev - 1));
      }, 1000);
    } else if (result.success && result.saved) {
      // Like added → increment
      setTimeout(() => {
        setFeedlike((prev) => prev + 1);
      }, 1000);
    } else {
      showToast("Failed to publish");
    }
  };
  return (
    <div >
      <Statusbar data={'Views Feed'} />
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>{data.title} | EditorTask.com</title>
          <meta name="description" content={data.description} />
          <meta name="keywords" content={data.keywords} />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content={`${data.title} | EditorTask.com`} />
          <meta property="og:description" content={`${data.description} | EditorTask.com`} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/skills-showcase" />
          <meta property="og:image" content="https://www.editortask.com/images/showcase_preview.png" />
        </Helmet>


        <div className="container_size">
          <br />
          <div className='post-container'>
            {/* <div className="contact-title">Showcase Your Creative Skills & Projects | EditorTask</div>    */}
          </div>

          <div className='post-container'>
            <div className='post_div'>
              <div className='view-body-div'>
                <div className='file-data-div'>
                  {data.file_url ? (
                    <img src={data.file_url} alt={data.title} className='file-data-img' />
                  ) : (
                    <Loadingimg />
                  )}
                </div>

                <div className='info-div'>
                  <div className='title-text'>{data.title}</div>

                </div>

                <div className='profile-body'>
                  {isLoading ? (
                    <Loadingimg />
                  ) : (
                    UsersData.map((user, index) => (
                      <>
                        <div className="prf-photo" key={index}  >
                          <img onClick={() => navigate('/' + user.slug)}
                            className="profile-img"
                            src={user.photoURL}
                            alt="User"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = Photosicon;
                            }}
                          />

                        </div>
                        <div className='prf-name'>
                          <table>
                            <tr><div onClick={() => navigate('/' + user.slug)} className='name-text'>{user.name}</div></tr>
                            <tr>
                              <td>
                                <div onClick={post_Savesubscriber} className="button-ui">
                                  {usersubscriber}
                                  <div className="subscriber-text">
                                    {yousubscribed ? "Subscribed" : "Subscribe"}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </>
                    ))
                  )}
                  <div className='likes-div'>
                    <div className='prf-share-btn'>
                      <div onClick={post_Savefeedlike} className='button-ui0'><AiFillLike className='icon' />{feedlike} Likes</div>
                    </div>
                    <ShareButton className='prf-share-btn' />
                  </div>
                </div>
                <div className='info-div'>

               
                      <div className='description-text'> 
                    <b>{data.views} Views, {GetAgoTime(data.date_time)+ ", " +
                                              data.date_time.toDate().toLocaleString('en-GB', {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true
                                              }).toUpperCase() 
                    
                    
                                              }</b>   <br/>
                    {data.description}</div>
                </div>
              </div>
            </div>
            <div className='post_updates'>
              <div className='recommend-div'>
                <div className='recommend-text active'>All</div>
                <div className='recommend-text'>Tech</div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}
